import {
  Breadcrumb as BreadcrumbComponent,
  BreadcrumbItem,
  BreadcrumbLink,
} from '@awaze/design-system.components.breadcrumb'
import { Container } from '@awaze/design-system.components.container'
import { pxToRems } from '@awaze/design-system.utils.react'
import { BreadcrumbItems } from 'src/utils/breadcrumb/breadcrumb-utils'
import styled from 'styled-components'

interface BreadcrumbsProps {
  breadcrumbs: BreadcrumbItems[]
}

const BreadcrumbContainer = styled.div`
  overflow: hidden;
  padding: ${pxToRems(48)} ${pxToRems(24)} 0;
`

export default function Breadcrumb({
  breadcrumbs,
}: Readonly<BreadcrumbsProps>): JSX.Element {
  return (
    <BreadcrumbContainer>
      <Container>
        <BreadcrumbComponent>
          {breadcrumbs.map(
            ({ slug, name }, index) =>
              name && (
                <BreadcrumbItem key={slug + index} dense>
                  <BreadcrumbLink href={slug}>{name}</BreadcrumbLink>
                </BreadcrumbItem>
              ),
          )}
        </BreadcrumbComponent>
      </Container>
    </BreadcrumbContainer>
  )
}
